import ROLES_PERMISSIONS from './roles_permissions.json';
export { ROLES_PERMISSIONS };
